import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'fsactividad',
    ...crudState(),
    activeView: 1,
    event: {},
    originalEvent: {},
    nuevaActividad: {},
    asignadasNew: JSON.parse(localStorage.getItem('asignadasNew')) || [],
    AddFecha: {
      cerrar: false,
      desde: 0,
      hasta: 0
    }
  }),
  getters: {
    ...crudGetters,
    asignadas: state => state.all.filter(item => item.idestado !== 4),
    finalizadas: state => state.all.filter(item => item.idestado === 4),
    sinasignar: state => state.all.filter(item => !!item.idusuarioasignado),
    activeView: state => state.activeView,
    evento: state => state.event,
    originalEvent: state => state.originalEvent,
    nuevaActividad: state => state.nuevaActividad,
    asignadasNew: state => state.asignadasNew,
    AddFecha: state => state.AddFecha
  },
  mutations: {
    ...crudMutations,
    setActiveView (state, value) {
      state.activeView = value
    },
    setEvent (state, event) {
      state.event = event
    },
    setOriginal (state, event) {
      state.originalEvent = event
    },
    setNuevaActividad (state, event) {
      state.nuevaActividad = event
    },
    setAsignadasNew (state, array) {
      state.asignadasNew = array
      localStorage.setItem('asignadasNew', JSON.stringify(array))
    },
    setAddFecha (state, obj) {
      state.AddFecha = obj
    }
  },
  actions: {
    ...crudActions,
    activateView ({ commit }, id) {
      commit('setOne', {}) // limpio el formulario
      commit('setActiveView', id)
    },
    uptAvent ({ commit }, event) {
      commit('setEvent', event)
    },
    originarEvent ({ commit }, event) {
      commit('setOriginal', event)
    },
    nuevaActividad ({ commit }, event) {
      commit('setNuevaActividad', event)
    },
    asignadasNew ({ commit }, array) {
      commit('setAsignadasNew', array)
    },
    addFecha ({ commit }, obj) {
      commit('setAddFecha', obj)
    }
  }
}
